/**
 * Tools Configuration
 * Single source of truth for tools metadata
 * Used by both client (React) and server (SSR meta injection)
 */

const toolsConfig = {
  // Main tools landing page
  landing: {
    title: 'Tools',
    description: 'Free AI-powered tools to help you work smarter.',
    subtitle: 'Free AI-powered tools to help you work smarter'
  },

  // Individual tools
  tools: {
    'article-to-media': {
      title: 'Article to Media',
      fullTitle: 'Article to Media - Transform Articles into Audio, Social Posts & Summaries',
      description: 'Transform any article URL into a 30-second audio narration, 3 unique social media posts with AI-generated images, and a 5-bullet TLDR summary.',
      shortDescription: 'Transform any article URL into audio narration, social media posts with AI-generated images, and a TLDR summary.',
      path: '/tools/article-to-media',
      tech: ['Node', 'React', 'OpenAI', 'Claude Code']
    }
  }
};

module.exports = toolsConfig;
